"use strict";function getInterface$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.getInterface$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="device.base.getInterface";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.4.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.4.0"},_a)),exports.getInterface$=getInterface$,exports.default=getInterface$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/device/base/getInterface.js
// module id = 1051
// module chunks = 106